import React, { useState } from "react";
import { useInterval, useTimeout } from "usehooks-ts";
import { Button } from "@picklebet/ui";
import { ReactComponent as SuccessArt } from "features/wallet/assets/success.svg";
import NextBettingButtons from "features/shell/components/shared/NextBettingButtons";
import { useDepositWizard } from "features/wallet/components/deposit/hooks/useDepositWizard";
import * as styles from "./DepositSuccess.module.scss";

const AUTO_CLOSE_SECONDS = 10;

export const DepositSuccess = () => {
  const { close } = useDepositWizard();
  const [secondsRemaining, setSecondsRemaining] = useState(AUTO_CLOSE_SECONDS);

  useTimeout(close, AUTO_CLOSE_SECONDS * 1000);

  useInterval(
    () => setSecondsRemaining((remaining) => remaining - 1),
    secondsRemaining > 0 ? 1000 : null,
  );

  return (
    <div className={styles.container}>
      <SuccessArt className={styles.art} />

      <div className={styles.title}>
        <h3>Deposit Successful</h3>
        <h5>Check out today's action to make a bet.</h5>
      </div>

      <NextBettingButtons buttonClass={styles.button} />

      <Button
        variant="secondary"
        size="sm"
        onClick={close}
        className={styles.done}
      >
        Done ({secondsRemaining}s)
      </Button>
    </div>
  );
};
